<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <div class="basic-title"><em>文案流程</em></div>
            <div class="process">
              <el-row
                :gutter="20"
                class="process-label">
                <el-col :span="12">
                  <label>入学时间：</label>
                  <el-date-picker
                    class="jm-input175"
                    v-model="listInfoData.startSchoolDateYear"
                    align="right"
                    type="year"
                    value-format="yyyy"
                    placeholder="选择年"
                    clearable/>
                  <el-date-picker
                    class="jm-input175"
                    v-model="listInfoData.startSchoolDateMonth"
                    type="month"
                    placeholder="选择月"
                    format="M"
                    value-format="M"
                    popper-class="process-list-popper"
                    clearable/>
                </el-col>
                <el-col :span="12">
                  <label>文案老师：</label>
                  <el-select
                    class="jm-input400"
                    v-model="listInfoData.crm_writer"
                    placeholder="请选择"
                    clearable>
                    <el-option-group
                      v-for="(group, k) in teacheres"
                      :key="k"
                      :label="k">
                      <el-option
                        v-for="item in group"
                        :key="item.userid"
                        :label="item.truename"
                        :value="item.userid"/>
                    </el-option-group>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <label>申请学校：</label>
                  <jm-school-search
                    class="jm-input400"
                    clearable
                    :country-id="83"
                    v-model="schoolModel"/>
                </el-col>
                <el-col :span="12">
                  <label>机场：</label>
                  <el-select
                    v-model="listInfoData.airport"
                    class="jm-input400"
                    clearable
                    placeholder="请选择">
                    <el-option
                      v-for="item in theAirport"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                  </el-select>

                </el-col>
                <el-col :span="12">
                  <label>是否需要接机：</label>
                  <el-select
                    class="jm-input400"
                    v-model="listInfoData.is_pickUp"
                    placeholder="请选择"
                    clearable>
                    <el-option
                      v-for="item in booleanOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <label>落地时间：</label>
                  <el-date-picker
                    v-model="listInfoData['pay_time_fall']"
                    type="datetimerange"
                    :editable="false"
                    unlink-panels
                    placeholder="选择日期"
                    class="jm-input400"/>
                </el-col>
              </el-row>
              <el-row/>
              <el-row class="process-bottom">
                <el-col :span="24">
                  <el-button
                    type="primary"
                    @click="() => { this.doRefresh = true; }">开始查询</el-button>
                </el-col>
              </el-row>
              <jm-tableList
                class="process-botton"
                url="index/Qc_process/getFlightList"
                :refresh.sync="doRefresh"
                :search-data="listInfoData">
                <el-table-column
                  slot="lastColumn"
                  label="操作"
                  width="80">
                  <template slot-scope="scope">
                    <router-link
                      target="_blank"
                      :to="{ name: 'editStudent', params: { id: scope.row.crm_id} }">
                      <el-button
                        size="mini"
                        type="primary">查看</el-button>
                    </router-link>
                  </template>
                </el-table-column>
              </jm-tableList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableList from '@/components/data/tableList.vue';
import { crumbs, jmAreaselect, jmSchoolSearch, jmDictSelect } from '@/components/tool/index.js';
import student from './student';
import writeProcess from './process.js';
import * as TeacherApi from '@/api/teacher.js';

export default {
  mixins: [writeProcess, student],
  data() {
    return {
      schoolModel: null,
      doRefresh: false,
      theAirport: '',
      listInfoData: { // 初始数据
        schoolId: '',
        startSchoolDateYear: '',
        startSchoolDateMonth: '',
        crm_writer: '',
        airport: '',
        is_pickUp: '',
        pay_time_fall: '',
      },
      teacheres: null,
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
    jmAreaselect,
    jmSchoolSearch,
    jmDictSelect
  },
  computed: {
  },
  mounted() {
    this.getTeachersOptions();
    this.landAirport().then((data) => {
      this.theAirport = data.land_airport;
    });
  },
  methods: {
    /*
    * 单独取出文案老师，因为数据库字段为数字
    * */
    getTeachersOptions() {
      TeacherApi.getWriteTeachers().then(({ data }) => {
        this.teacheres = this.formatTeacher(data);
      });
    },
    landAirport() {
      return new Promise((resolve) => {
        this.$http._post({
          url: '/index/Qc_process/getAirportList',
        }).then(({ data }) => {
          resolve(data);
        });
      });
    }
  },
  watch: {
    schoolModel(val) {
      this.listInfoData.schoolId = val ? val.sh_id : null;
    },
    'listInfoData.startSchoolDateYear' (val) {
      if (!val) {
        this.listInfoData.startSchoolDateMonth = '';
      }
    },
    'listInfoData.startSchoolDateMonth' () {
      if (!this.listInfoData.startSchoolDateYear) {
        this.listInfoData.startSchoolDateMonth = '';
      }
    },
  }
};
</script>
<style>
  tr.row-gray {
    color: #D7D7D7
  }
</style>
<style scoped>
  .process-label label {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
  .process-label .el-col-12{
    margin-bottom: 10px;
    padding: 0 !important;
  }
  .process-bottom {
    margin-bottom: 10px;
    text-align: center;
  }
  .list-botton{
    margin-bottom: 10px;
  }
</style>
